<section
  class="dashboard-widget-shell card"
  [class.dashboard-widget-shell--edit]="editMode"
  [class.dashboard-widget-shell--collapsed]="widget?.collapsed && !editMode"
  [attr.data-widget-id]="widget?.id">
  <header class="dashboard-widget-shell__header" *ngIf="showChrome && (chromeInViewMode || editMode)">
    <div class="dashboard-widget-shell__title-row">
      <span class="dashboard-widget-shell__drag-handle" *ngIf="editMode" cdkDragHandle title="Drag to reorder">
        <i class="fa fa-arrows" aria-hidden="true"></i>
      </span>
      <h6 class="dashboard-widget-shell__title mb-0">{{ meta?.title || widget?.id }}</h6>
    </div>
    <div class="dashboard-widget-shell__actions">
      <ng-container *ngIf="editMode">
        <label class="dashboard-widget-shell__show mr-2 mb-0">
          <input
            type="checkbox"
            [checked]="widget?.visible"
            (change)="onVisibilityChange($event)" />
          Show
        </label>
        <select
          class="form-control form-control-sm dashboard-widget-shell__size-select"
          [value]="widget?.colSpan"
          (change)="onColSpanSelect($any($event.target).value)">
          <option *ngFor="let s of colSpanOptions" [value]="s">{{ s }}/12 width</option>
        </select>
      </ng-container>
      <button
        type="button"
        class="btn btn-link btn-sm dashboard-widget-shell__collapse-btn p-0"
        *ngIf="!editMode"
        (click)="collapsedToggle.emit()"
        [attr.aria-expanded]="!widget?.collapsed"
        [title]="widget?.collapsed ? 'Expand widget' : 'Collapse widget'">
        <i class="fa" [ngClass]="widget?.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'" aria-hidden="true"></i>
      </button>
    </div>
  </header>
  <div class="dashboard-widget-shell__body" [class.d-none]="widget?.collapsed && !editMode">
    <ng-content></ng-content>
  </div>
</section>
